(function ($) {

	let previousAjaxRequest = null;
	let ajaxSearchTimeout = null;

    $.fn.advcombo = function( options ) {
            
            return this.each(function () {

                const $me = $(this);
				if($me.data('initialized')) return true;
				$me.data('initialized', true);
	        	const $field = $me.find('.advcombo-field');
	        	const $layer = $me.find('.advcombo-layer');
	        	const $list = $layer.find('.advcombo-list');
	        	const $value = $me.find('.advcombo-value');

	        	const settings = $.extend({
		            query: null,
		        	entityname: null,
		        	createnew: false,
					searchDelay: 300,
					minCharCount: 0,
		        	onselect: function() {},
		        	onremove: function() {},
					onenter: function() {}
        		}, options );
	        	
	        	if(settings.query !== null) $me.data('query', settings.query);
	        	if(settings.createnew !== false) $me.data('createnew', settings.createnew);
	        	if(settings.entityname !== null) $me.data('entityname', settings.entityname);
	        		        	
	        	function requestItems(searchTerm, showEntityInfo) {
					
					if (!$me.data('query')) return;

					if(previousAjaxRequest !== null) {
						previousAjaxRequest.abort();
					}

					if (searchTerm.length < settings.minCharCount) {
						$list.html('<li class="advcombo-list-info info-no-match">mind. ' + settings.minCharCount + ' Zeichen eingeben</li>');
						return;
					}

					previousAjaxRequest = $.ajax({
						url: $me.data('query'),
						data: {term: searchTerm},
						contentType: "application/json; charset=UTF-8",
						dataType: "json",
						success: function (data) {

							if(data.sessionExpired) {
								window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
								return;
							}

							previousAjaxRequest = null;
							$list.html('');

							const _items = data.items;
							const _isSafeLabel = data.isSafeLabel;

							if (_items.length === 0) {
								if ($me.data('createnew')) {
									$list.append('<li class="advcombo-list-info info-create-new">Nichts gefunden - erzeuge Eintrag</li>');
								} else {
									$list.append('<li class="advcombo-list-info info-no-match">Nichts gefunden</li>');
								}
							}
							$.each(_items, function (index, item) {
								let $li_template;
								let $a;
								if(util.isEmpty(item.id)) {
									$li_template = $('<li title="" class="advcombo-entity-label"></li>');
									$a = $li_template;
								} else {
									$li_template = $('<li><a title="" data-id="" href="#"></a></li>');
									$a = $li_template.find('a');
								}

								if (item.icon) {
									const $icon = $('<span class="advcombo-list-icon"><img src="" alt=""></span>');
									$icon.find('img')
										.attr('alt', item.id)
										.attr('src', item.icon)
										.appendTo($a);
								}

								const labelHtml = _isSafeLabel ? item.label : util.escapeHtml(item.label);
								$a.append(labelHtml)
									.attr('title', _isSafeLabel ? util.unescapeHtml(item.label) : item.label)
									.attr('data-id', item.value);

								$list.append($li_template);
							});

							if (showEntityInfo && $me.data('entityname') !== null && _items.length !== 0) {
								$list.append('<li class="advcombo-list-section-footer">Tippen um ' + util.escapeHtml($me.data('entityname')) + ' zu suchen...</li>');
							}

							if ($value.length > 0) {
								$list.find('a[data-id="' + $value.val() + '"]').addClass('selected');
							}
						}
					});
				}

	        	$me.find('.advcombo-icon').click(function(e) {
	        		//lastClick = e.target;
	        		if(!$layer.is(':visible')) {
	        			$field.select();
	        			$list.find('a[data-id="' + $value.val() + '"]').addClass('selected');
						$layer.show();
						requestItems($field.val(), true);
					}
	        	});

	        	let lastClick = null;
	        	$field.mousedown(function(e) {
	        		lastClick = e.target;
	        		$(this).select();
	        		$list.find('a[data-id="' + $value.val() + '"]').addClass('selected');
					$layer.show();
					requestItems($field.val(), true);
	        	}).focus( function(e) {
	        		if (e.target !== lastClick) {
	        			$list.find('a[data-id="' + $value.val() + '"]').addClass('selected');
						$layer.show();
						requestItems("", true);
	        		}
	        		lastClick = null;
	        	});

				$(document).click(function(e) {
					if($(e.target).parents('.field-item-advcombo, .advcombo').length === 0) {
						setTimeout(function(){ 
							const activevalue = $value.val();

							if($me.data('createnew') === false && activevalue === '') {
								$field.val('');
							}

							$layer.hide();
						}, 100);
					}
				});

				$list.on('click', 'a', function() {

					const $icon = $(this).find('.advcombo-list-icon');

					if($icon.length > 0) {
						$me.find('.advcombo-entity-icon').html( $icon.html() );
					} else {
						$me.find('.advcombo-entity-icon').html('');
					}

					const textvalue = $(this).attr('title');
					const idvalue = $(this).data('id');

					$field.val(textvalue);
					$field.attr('title', textvalue);
					$value.val(idvalue);

					settings.onselect.call($me, idvalue, textvalue);
					$field.trigger('change');

					$layer.hide();

					return false;
				});

				$field.blur( function(e) {
					if(util.isEmpty($value.val())) {
						$field.val('');
					}
				});

				$field.keyup(function (e){

					let $selecteditem = $list.find('.selected');

					if(e.keyCode === 9 || e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 37 || e.keyCode === 39) {
						return;
					}

					if(e.keyCode === 38) {
						if($selecteditem.length > 0) {
							if($selecteditem.parent().prev().find('a').length > 0) {
								$selecteditem = $selecteditem.removeClass('selected').parent().prev().find('a');
							} else {
								$selecteditem = $selecteditem.removeClass('selected').parent().parent().find('a:last');
							}
							$selecteditem.addClass('selected');
						}
					} else if(e.keyCode === 40) {
						if($selecteditem.length > 0) {
							if($selecteditem.parent().next().find('a').length > 0) {
								$selecteditem = $selecteditem.removeClass('selected').parent().next().find('a');
							} else {
								$selecteditem = $selecteditem.removeClass('selected').parent().parent().find('a:first');
							}
							$selecteditem.addClass('selected');
						}
					} else if(e.keyCode === 13){
						$selecteditem.trigger('click');
						if($selecteditem.length === 0) {
							settings.onenter.call($me);
						}
					} else {
						$value.val('');
						$field.trigger('change');
						settings.onremove.call($me);

						clearTimeout(ajaxSearchTimeout);
						ajaxSearchTimeout = setTimeout(function(){
							requestItems($field.val(), false);
						}, settings.searchDelay);

					}

				});
            });
        };
       
})(jQuery);